import React from 'react';
import styles from './ReportHeader.module.css';

const ReportHeader = ({ 
    outletName, 
    periodText,
    categoryText,
    onDownload, 
    downloadLoading = false,
    hasData = true,
    downloadButtonText = 'Download CSV',
    hideDownload = false,
    disableDownload = false
}) => {
    return (
        <div className={styles.reportHeader}>
            <div className={styles.reportInfo}>
                <div className={styles.infoItem}>
                    <span className={styles.infoLabel}>Outlet:</span>
                    <span className={styles.infoValue}>{outletName || 'N/A'}</span>
                </div>
                <div className={styles.infoItem}>
                    <span className={styles.infoLabel}>Period:</span>
                    <span className={styles.infoValue}>{periodText || 'N/A'}</span>
                </div>
                {categoryText ? (
                    <div className={styles.infoItem}>
                        <span className={styles.infoLabel}>Category:</span>
                        <span className={styles.infoValue}>{categoryText}</span>
                    </div>
                ) : null}
            </div>
            {!hideDownload && (
                <button 
                    className={styles.downloadButton} 
                    onClick={onDownload}
                    disabled={downloadLoading || !hasData || disableDownload}
                >
                    {downloadLoading ? 'Downloading...' : downloadButtonText}
                </button>
            )}
        </div>
    );
};

export default ReportHeader;
